import {PostCardProps} from 'components/blog/PostCard';
import {parsePosts} from 'components/blog/useBlogs/parsers';
import {QueryResult} from 'components/blog/useBlogs/types';
import {cmsEnv} from 'creates/env';
import {graphql, useStaticQuery} from 'gatsby';
import {sortkey} from 'utils/sort';

const query = graphql`
{
	posts: allAirtable(
		filter: {
			table: {
				eq: "Posts"
			}
			data: {
				Slug: {
					in: [
						"5_super_quick_tips_on_lean_tissue_for_beginners",
						"a_guide_to_osteopenia",
						"all_about_the_rmr_test",
						"appendicular_lean_mass_and_almilongevity",
						"appendicular_lean_mass_and_sarcopenia",
						"bones_make_it_or_break_it",
						"calculating_your_resting_metabolic_rate",
						"gaining_lean_muscle_a_comprehensive_guide",
						"how_does_caffeine_affect_my_rmr",
						"lose_fat_and_gain_muscle_is_it_possible",
						"muscle_vs_lean_what_does_it_mean",
						"subcutaneous_fat_what_it_is_and_how_to_reduce_it",
						"the_hard_facts_about_bone",
						"visceral_fat_level_chart_understanding_your_health_risks",
						"visceral_fat_percentile_charts",
						"what_does_body_fat_percentage_really_mean",
						"what_is_a_healthy_visceral_fat_level",
						"why_is_appendicular_lean_mass_important",
					]
				}
			}
		}
	) {
		nodes {
			data {
				...PostFields

				# Using images here since we've already
				# filtered to only the few slugs we need
				...PostImages
			}
		}
	}
}`;

export const useSelected = (slugs: string[]): PostCardProps[] => {
	const {posts: {nodes}} = useStaticQuery<QueryResult>(query);
	const env = cmsEnv();

	const posts = nodes
		.map(({data}) => data)
		.filter(({envs}) => envs.includes(env))
		.filter(({slug}) => slugs.includes(slug))
		.sort(sortkey(({slug}) => slugs.indexOf(slug)));

	const valids = posts.map(({slug}) => slug);
	for (const slug of slugs) {
		if (!valids.includes(slug)) {
			throw new Error('Update GQL query to include: ' + slug);
		}
	}

	return parsePosts(posts);
};
